module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921022651_T.557afb93.jpg";